import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import styles from "./AgentPlanList.module.css";
import AdminHeader from "../Header/AdminHeader";
import AdminLeftMenu from "../Navbar/AdminLeftMenu";
import { NODE_HOST_URL } from "../Dashboard/api/Api";
import axios from "../../axios/Axios";
import { userloginDetails } from "../Utils/AdminAuth";
// import { toast } from "react-toastify";

const AgentBill = () => {
    const history = useHistory();
    const [searchUsers, setSearchUsers] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [isSearching, setIsSearching] = useState(false);
    const [activeFilter, setActiveFilter] = useState("plan");
    const [pendingUsersTotal, setPendingUsersTotal] = useState(0);
    const [planTotal, setPlanTotal] = useState(0);
    const [planPage, setPlanPage] = useState(1);
    const [planLimit] = useState(10);
    const [planPagination, setPlanPagination] = useState({ page: 1, limit: 10, total: 0, total_pages: 1 });
    const [isPlanServerPaginated, setIsPlanServerPaginated] = useState(true);

      const lStorage  = userloginDetails();
      const userId    = lStorage?.user?.userId;
      const userToken = lStorage?.token;

    const fetchUsers = async (query, method = "active_plan_users", page = 1) => {
        try {
            setIsSearching(true);
            const payload = {
                "user_id": userId,
                "token": userToken,
                "method": method
            };
            if (method !== "get_pending_bill_users") {
                payload.search = query;
            }
            if (method === "active_plan_users") {
                payload.page = page;
                payload.limit = planLimit;
            }

            const response = await axios.post(`${NODE_HOST_URL}/agent_management`, payload);
            const result = response.data;
            if (result.success) {
                setSearchUsers(result.data || []);
                if (Number.isFinite(Number(result.pending_bill_users_total))) {
                    setPendingUsersTotal(Number(result.pending_bill_users_total));
                }
                if (Number.isFinite(Number(result.plan_total))) {
                    setPlanTotal(Number(result.plan_total));
                }
                if (method === "active_plan_users") {
                    if (result.pagination) {
                        setIsPlanServerPaginated(true);
                        setPlanPagination(result.pagination);
                    } else {
                        const total = (result.data || []).length;
                        setIsPlanServerPaginated(false);
                        setPlanPagination({
                            page,
                            limit: planLimit,
                            total,
                            total_pages: Math.max(1, Math.ceil(total / planLimit))
                        });
                    }
                }
            }
        } catch (error) {
            console.error("Error searching users:", error);
            // toast.error(error.response?.data?.message || "Failed to search users. Please try again later.");
        } finally {
            setIsSearching(false);
        }
    };

    const handleSelectUser = (user) => {
        const clientId = user?.user_id || user?.id || user?._id;
        if (!clientId) return;
        history.push(`/admin/agent-bill/${clientId}`, { user });
    };

    useEffect(() => {
        fetchUsers("", activeFilter === "pending" ? "get_pending_bill_users" : "active_plan_users", planPage);
    }, [activeFilter, planPage]);

    useEffect(() => {
        const handler = setTimeout(() => {
            fetchUsers(
                searchTerm.trim(),
                activeFilter === "pending" ? "get_pending_bill_users" : "active_plan_users",
                planPage
            );
        }, 800);

        return () => clearTimeout(handler);
    }, [searchTerm, activeFilter, planPage]);

    return (
        <div className="wrapper">
            <AdminLeftMenu />
            <div className="main">
                <AdminHeader />
                <div className="container-fluid p-3 p-md-4">

                    {/* PAGE HEADER */}
                    <div className="d-flex justify-content-between align-items-center mt-3 mb-4">
                        <div>
                            <h5 className={styles.pageTitle}>Agent Bills</h5>
                            <div className={styles.subtitle}>
                                Monitor and manage agents, billing, and performance across all clients.
                            </div>
                        </div>
                    </div>
                    <div className={`${styles.summaryRow} mb-3`}>
                          <button
                            type="button"
                            className={`${styles.summaryCard} ${activeFilter === "plan" ? styles.summaryCardActive : ""}`}
                            onClick={() => setActiveFilter("plan")}
                        >
                            <div className={styles.summaryLabel}>Plan Total</div>
                            <div className={styles.summaryValue}>{planTotal}</div>
                        </button>
                        <button
                            type="button"
                            className={`${styles.summaryCard} ${activeFilter === "pending" ? styles.summaryCardActive : ""}`}
                            onClick={() => setActiveFilter("pending")}
                        >
                            <div className={styles.summaryLabel}>Pending Bill Users</div>
                            <div className={styles.summaryValue}>{pendingUsersTotal}</div>
                        </button>
                      
                    </div>

                    <div className={styles.filterCard}>
                        <div className={styles.filterRow}>
                            <div className={styles.filterFieldWide}>
                                <label className={styles.formLabel}>Search Users</label>
                                <div className={styles.searchBox}>
                                    <input
                                        placeholder="Search username"
                                        value={searchTerm}
                                        onChange={(event) => setSearchTerm(event.target.value)}
                                    />
                                </div>
                            </div>
                            <div className={styles.filterActions}>
                                {isSearching && <div className="text-muted small">Searching...</div>}
                            </div>
                        </div>
                        <div className="text-muted small mt-2">
                            Type a username to filter. Click a user to load bills.
                        </div>
                    </div>

                    {isSearching && (
                        <div className="text-muted small mt-3">Loading users...</div>
                    )}
                   <div className={`${styles.tableWrapper} mt-3`}>
    <div className="table-responsive">
        <table className="table table-hover align-middle mb-0">
            <thead style={{ background: "#f8fafc" }}>
                <tr>
                    <th style={{ width: 80 }}>S. No.</th>
                    <th style={{ width: 140 }}>User Id</th>
                    <th>Username</th>
                    <th style={{ width: 180 }}>Pending Bill Amount</th>
                    <th style={{ width: 160 }}>Pending Bill Count</th>
                    <th style={{ width: 140 }}></th>
                </tr>
            </thead>

            <tbody>
                {searchUsers.length === 0 && (
                    <tr>
                        <td colSpan={6} className="text-center text-muted py-4">
                            {isSearching ? "Loading users..." : "No users found."}
                        </td>
                    </tr>
                )}

                {(activeFilter === "plan" && !isPlanServerPaginated
                    ? searchUsers.slice((planPage - 1) * planLimit, planPage * planLimit)
                    : searchUsers
                ).map((user, index) => {
                    const userIdValue = user.user_id || user.id || "-";
                    const userName = user.username || user.name || user.user_name || "-";
                    const pendingAmount = activeFilter === "pending"
                        ? "-"
                        : (user.pending_bill_amount ?? 0);
                    const pendingCount = activeFilter === "pending"
                        ? "-"
                        : (user.pending_bill_count ?? 0);

                    return (
                        <tr
                            key={user.user_id || user.id || index}
                            role="button"
                            onClick={() => handleSelectUser(user)}
                        >
                            <td>{index + 1}</td>

                            <td className={styles.idCell}>{userIdValue}</td>

                            <td>
                                <div className={styles.userCell}>
                                    <div className={styles.userName}>{userName}</div>
                                </div>
                            </td>

                            <td>{pendingAmount}</td>

                            <td>{pendingCount}</td>

                            <td className="text-end">
                                <button
                                    className={styles.actionBtn}
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        handleSelectUser(user);
                                    }}
                                >
                                    View Bills
                                </button>
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    </div>
</div>
                    {activeFilter === "plan" && (
                        <div className={styles.detailPagination}>
                            <div className={styles.detailPagInfo}>
                                Page {planPagination.page} of {planPagination.total_pages} &nbsp;·&nbsp; Total {planPagination.total}
                            </div>
                            <div className={styles.detailPagButtons}>
                                <button
                                    className={styles.detailPagBtn}
                                    onClick={() => setPlanPage((prev) => Math.max(1, prev - 1))}
                                    disabled={planPage <= 1}
                                >
                                    Previous
                                </button>
                                <div className={styles.detailPagPage}>{planPage}</div>
                                <button
                                    className={styles.detailPagBtn}
                                    onClick={() => setPlanPage((prev) => Math.min(planPagination.total_pages, prev + 1))}
                                    disabled={planPage >= planPagination.total_pages}
                                >
                                    Next
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};


export default AgentBill;